/** CSV helpers for report exports (shared by ReportModal and Audience check). */

export function escapeCsvCell(value: unknown): string {
    if (value === null || value === undefined) {
        return '';
    }
    const s = String(value);
    if (/[",\r\n]/.test(s)) {
        return `"${s.replace(/"/g, '""')}"`;
    }
    return s;
}

/** Builds CSV text from an array of objects (uses union of keys across rows), or other JSON-serializable shapes. */
export function dataToCsv(data: unknown): string {
    if (data === null || data === undefined) {
        return '';
    }
    if (Array.isArray(data)) {
        if (data.length === 0) {
            return '';
        }
        const first = data[0];
        if (
            typeof first === 'object' &&
            first !== null &&
            !Array.isArray(first)
        ) {
            const keySet = new Set<string>();
            for (const row of data) {
                if (typeof row === 'object' && row !== null) {
                    Object.keys(row as object).forEach(k => keySet.add(k));
                }
            }
            const headers = [...keySet];
            const lines = [
                headers.map(escapeCsvCell).join(','),
                ...data.map(row => {
                    const r = row as Record<string, unknown>;
                    return headers.map(h => escapeCsvCell(r[h])).join(',');
                }),
            ];
            return lines.join('\r\n');
        }
        return data.map(escapeCsvCell).join('\r\n');
    }
    if (typeof data === 'object') {
        const r = data as Record<string, unknown>;
        const headers = Object.keys(r);
        return [
            headers.map(escapeCsvCell).join(','),
            headers.map(h => escapeCsvCell(r[h])).join(','),
        ].join('\r\n');
    }
    return escapeCsvCell(data);
}
